type Styles = {
  horizontal?: string
  vertical?: string
  square?: string
}

export type ImageAspectRatio = {
  width: number
  height: number
} | null

export function getImageAspectRatioClass(
  styles: Styles,
  image: ImageAspectRatio
): string {
  if (!image) {
    return ''
  }

  const aspectRatio = image.width / image.height

  if (aspectRatio > 1.6) {
    return styles.horizontal ?? 'horizontal'
  }

  if (aspectRatio < 0.8) {
    return styles.vertical ?? 'vertical'
  }

  return styles.square ?? 'square'
}
